
import { useCallback, useReducer } from 'react'
import { buyBudget } from '../models/buyBudget'
import { buyBudgetReducer } from '../reducers/buyBudgetReducer'

const initialState = {
    buyBudgets: [],
    detailBuyBudget: [],
}

export const useBuyBudget = () => {

    const [state, dispatch] = useReducer(buyBudgetReducer, initialState)
    const { buyBudgets, detailBuyBudget } = state

    const initGetAllBuyBudgets = useCallback(async (filters = {}) => {
        const data = await buyBudget.getAll(filters)

        const action = {
            type: '[BUYBUDGET] Load list',
            payload: data
        }

        dispatch(action)
    }, [])

    const initGetOneBuyBudgets = async (buyBudgetId) => {
        const data = await buyBudget.getOne(buyBudgetId)

        const action = {
            type: '[BUYBUDGET] Set detail',
            payload: data
        }

        dispatch(action)

    }

    const initSaveBuyBudget = async (newBuyBudget) => {
        const result = await buyBudget.save(newBuyBudget)

        if (result) {

            const action = {
                type: '[BUYBUDGET] Set detail',
                payload: result
            }

            dispatch(action)

        }

    }

    const initUpdateBuyBudget = async (editBuyBudget) => {
        const result = await buyBudget.update(editBuyBudget)

        if (result) {

            const action = {
                type: '[BUYBUDGET] Set detail',
                payload: result
            }

            dispatch(action)

        }

    }

    const initExport = async (filters) => {
        await buyBudget.getExport(filters)
    }

    return {
        buyBudgets,
        detailBuyBudget,
        initGetAllBuyBudgets,
        initGetOneBuyBudgets,
        initSaveBuyBudget,
        initUpdateBuyBudget,
        initExport
    }

}